/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import MaskedInput from 'react-text-mask';

export default function Input({ focus, className, sm, md, lg, mask, ...args }) {
  const elm = useRef();

  useEffect(() => {
    if (focus && !mask) elm.current.focus();
  }, [focus]);

  return !mask ? (
    <input
      {...args}
      ref={elm}
      className={classnames(
        'form-control',
        className,
        sm && 'form-control-sm',
        md && 'form-control-md',
        lg && 'form-control-lg',
      )}
    />
  ) : (
    <MaskedInput
      {...args}
      ref={elm}
      guide={false}
      mask={mask}
      className={classnames(
        'form-control',
        className,
        sm && 'form-control-sm',
        md && 'form-control-md',
        lg && 'form-control-lg',
      )}
    />
  );
}
